/****************************************************************************
 **
 ** Copyright (C) 2021 The Qt Company Ltd.
 ** Contact: https://www.qt.io/licensing/
 **
 ** This file is part of Qt Bridge Plugin.
 **
 ** Commercial License Usage
 ** Licensees holding valid commercial Qt licenses may use this file in
 ** accordance with the commercial license agreement provided with the
 ** Software or, alternatively, in accordance with the terms contained in
 ** a written agreement between you and The Qt Company. For licensing terms
 ** and conditions see https://www.qt.io/terms-conditions. For further
 ** information use the contact form at https://www.qt.io/contact-us.
 **
 ****************************************************************************/

const HAlighMapping = new Map([
    ["RIGHT", "ENUM(Text.AlignRight)"],
    ["CENTER", "ENUM(Text.AlignHCenter)"],
    ["JUSTIFIED", "ENUM(Text.AlignJustify)"],
    ["LEFT", "ENUM(Text.AlignLeft)"],
    ["", "ENUM(Text.AlignLeft)"]
]);

const VAlighMapping = new Map([
    ["TOP", "ENUM(Text.AlignTop)"],
    ["CENTER", "ENUM(Text.AlignVCenter)"],
    ["BOTTOM", "ENUM(Text.AlignBottom)"],
    ["", "ENUM(Text.AlignBottom)"]
]);

export class SStyle {
    constructor(styleObject) {
        this._styleInstance = styleObject.sketchObject;
        this._style = styleObject.toJSON();
    }

    opacity() {
        return this._style ? this._style.opacity : 1;
    }

    isTextStyle() {
        return this._style && this._style.styleType + "" === "Text";
    }

    static sharedTextStyle(id, sDoc) {
        let d = sDoc.instance();
        if (!id || !d || !d.sharedTextStyles) {
            return null;
        }

        for (const obj of d.sharedTextStyles) {
            if (obj.id === id) {
                return obj.style;
            }
        }
        return null;
    }

    toTextDetails() {
        let result = {};
        if (!this.isTextStyle()) {
            return result;
        }
        result.fontFamily = this._style.fontFamily;
        result.fontSize = this._style.fontSize;
        result.fontStyle = this._style.fontStyle;
        if (this._style.kerning) {
            result.kerning = this._style.kerning;
        }
        result.textColor = this._style.textColor;
        result.lineHeight = this._style.lineHeight;
        result.horizontalAlignment = this._style.alignment;
        result.verticalAlignment = this._style.verticalAlignment;

        try {
            result.fontDisplayName = this._styleInstance.primitiveTextStyle().decodedAttributes().valueForKey("NSFont").displayName() + "";
        } catch (e) {
            console.log(`Text style information not available ${e}`)
        }
        return result;
    }

    toQmlProperties() {
        let textDetails = this.toTextDetails();
        let result = {};
        result.color = textDetails.textColor;
        result.verticalAlignment = toAlighMapping(textDetails.verticalAlignment, VAlighMapping);
        result.horizontalAlignment = toAlighMapping(textDetails.horizontalAlignment, HAlighMapping);
        if (textDetails.lineHeight) {
            result.lineHeight = textDetails.lineHeight.toFixed(3);
        }
        result["font.family"] = `"${textDetails.fontFamily}"`;
        result["font.pixelSize"] = textDetails.fontSize;
        if (result.kerning) {
            result["font.letterSpacing"] = textDetails.kerning.toFixed(3);
        }
        if (textDetails.fontStyle) {
            result["font.italic"] = textDetails.fontStyle.toUpperCase() === "ITALICS";
            result["font.bold"] = textDetails.fontStyle.toUpperCase() === "BOLD";
        }
        return result;
    }
}

function toAlighMapping(value, mapping) {
    let result = mapping.get("");
    value = ("" + value).toUpperCase();
    if (mapping.has(value)) {
        result = mapping.get(value);
    }
    return result;
}
